import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Apis } from "../../../lib/Apis";
import "../login-page/style.css";

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    }
  }, [navigate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const password = formData.password.trim();
    const confirmPassword = formData.confirmPassword.trim();

    if (password.length < 8) {
      Swal.fire({
        icon: "warning",
        title: "Weak password",
        text: "Password must be at least 8 characters long.",
      });
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Passwords do not match",
        text: "Please enter the same password in both fields.",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await Apis.resetPassword({
        newPassword: password,
      });

      if (response?.status === 200 || response?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "Password reset",
          text: response?.data?.message || "Your password has been reset successfully.",
        });

        localStorage.removeItem("token");
        navigate("/login");
      } else {
        Swal.fire({
          icon: "error",
          title: "Reset failed",
          text:
            response?.data?.message ||
            "Unable to reset your password right now.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Reset failed",
        text:
          error?.response?.data?.message ||
          "Unable to reset your password right now.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-main-layout">
      <div className="auth-glass-box">
        <form onSubmit={handleSubmit}>
          <h1>Set New Password</h1>
          <p className="auth-centered-text" style={{ marginTop: 10 }}>
            Please enter your new password below.
          </p>

          <div className="auth-field-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="New Password"
              value={formData.password}
              onChange={handleChange}
            />
            <i
              className={`bx ${showPassword ? "bxs-show" : "bxs-hide"}`}
              onClick={() => setShowPassword(!showPassword)}
              style={{ cursor: "pointer" }}
            ></i>
          </div>

          <div className="auth-field-wrapper">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
            <i
              className={`bx ${showConfirmPassword ? "bxs-show" : "bxs-hide"}`}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{ cursor: "pointer" }}
            ></i>
          </div>

          <button
            type="submit"
            className="auth-login-action"
            disabled={loading}
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
